import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bowser from 'yola-bowser';

const ActionList = ({ children, ...otherProps }) => {
  const isMobile = bowser.mobile;

  const classes = classNames('ws-ui-action-list', {
    'ws-ui-action-list--mobile': isMobile,
  });

  return (
    <div className={classes} {...otherProps}>
      {children}
    </div>
  );
};

ActionList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ActionList;
